module.exports = __webpack_public_path__ + "img/icon_menu_magazine_2.173c4dd9.svg";